import { useParams, Link, Navigate } from 'react-router-dom';
import { blogPosts } from '../data/blogposts';
import { norppa, company } from '../data/content';
import usePageMeta from '../hooks/usePageMeta';

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  usePageMeta({
    title: post ? `${post.title} - Pulmakivi` : 'Pulmakivi',
    description: post?.metaDescription || '',
    canonical: post ? `https://pulmakivi.fi/ajankohtaista/${post.slug}` : 'https://pulmakivi.fi/ajankohtaista',
    image: post?.image,
  });

  if (!post) return <Navigate to="/ajankohtaista" replace />;

  return (
    <article className="blog-post">
      <Link to="/ajankohtaista" className="blog-post__back">&larr; Kaikki kirjoitukset</Link>
      <h1 className="page__title">{post.title}</h1>
      <p className="blog-post__meta">{post.date} · {post.author}</p>
      <p className="blog-post__intro">{post.intro}</p>

      {post.image && (
        <img src={post.image} alt={post.imageAlt || post.title} className="blog-post__image" />
      )}

      {post.sections.map((section, i) => (
        <section key={i} className="blog-post__section">
          <h2>{section.title}</h2>
          <p>{section.content}</p>
          {section.list && (
            <ul className="blog-post__list">
              {section.list.map((item, j) => (
                <li key={j}>{item}</li>
              ))}
            </ul>
          )}
          {section.contentAfter && <p>{section.contentAfter}</p>}
        </section>
      ))}

      <div className="blog-post__cta">
        <a href={norppa.googlePlayUrl} target="_blank" rel="noopener noreferrer" className="btn">
          Lataa Norppa Google Playsta &rarr;
        </a>
      </div>

      <p className="blog-post__contact">
        Kysyttävää tai palautetta? Ota yhteyttä: <a href={`mailto:${company.email}`}>{company.email}</a>
      </p>
    </article>
  );
}
